@let currentSelectionState = selectionState();
@let isSelectionStateNone = currentSelectionState === 'none';
<a
        type="button"
        sbTooltip="{{ (isSelectionStateNone? 'lang.globals.selectAll' : 'lang.globals.deselectAll') | translate }}"
        (click)="action.emit( isSelectionStateNone ? 'selectPage' : 'deselectPage')"
        class="tw-text-2xl"
>
    @switch (currentSelectionState) {
        @case ('all') {
          <sb-icon [icon]="'boxCheckedFilled'" class="tw-text-sbBlue-500" [highlightClass]="'tw-text-white '"></sb-icon>
        }
        @case ('none') {
          <sb-icon [icon]="'boxBackground'" class="tw-text-white dark:tw-text-sbGrayBlue-950"
                   [highlightClass]="'tw-text-sbBlue-200 dark:tw-text-sbBlue-500'"></sb-icon>
        }
        @case ('partly') {
            <sb-icon [icon]="'boxMinusFilled'" class="tw-text-sbBlue-500" [highlightClass]="'tw-text-white'"></sb-icon>
        }
    }
</a>
